import { labelids } from "../../assets/data/TkExplanationProperty";

const manualList: {
  title: string; // 見出し
  introduction?: string; // 説明
  section: {
    index: string; // 小見出し
    text: string; // 説明文
    link: string; // ファイルリンク
  }[];
}[] = [
  {
    title: "契約",
    section: [
      {
        index: "社会福祉施設職員等退職手当共済契約申込書の提出手続き",
        text: labelids.labelid.SCRC020002_02,
        link: "社会福祉施設職員等退職手当共済契約申込書の提出手続き.pdf",
      },
    ],
  },
  {
    title: "施設の新設",
    section: [
      {
        index: "施設等新設届・申出書の提出手続き",
        text: labelids.labelid.SCRC020002_03,
        link: "施設等新設届・申出書の提出手続き.pdf",
      },
    ],
  },
  {
    title: "職員の加入",
    section: [
      {
        index: "被共済職員加入届の提出手続き",
        text: labelids.labelid.SCRC020002_04,
        link: "被共済職員加入届の提出手続き.pdf",
      },
    ],
  },
  {
    title: "掛金届の提出・掛金の納付",
    section: [
      {
        index: "掛金納付対象職員届の提出手続き",
        text: labelids.labelid.SCRC020002_05,
        link: "掛金納付対象職員届の提出手続き.pdf",
      },
      {
        index:
          "掛金の振込依頼書及び掛金納付対象職員届（共済契約者控え）のダウンロード手続き",
        text: labelids.labelid.SCRC020002_06,
        link: "掛金の振込依頼書及び掛金納付対象職員届（共済契約者控え）のダウンロード手続き.pdf",
      },
      {
        index:
          "都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意にかかる有無選択手続き",
        text: labelids.labelid.SCRC020002_07,
        link: "都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意にかかる有無選択手続き.pdf",
      },
      {
        index: "掛金納付期限延長申請書の提出手続き",
        text: labelids.labelid.SCRC020002_08,
        link: "掛金納付期限延長申請書の提出手続き.pdf",
      },
    ],
  },
  {
    title: "職員の退職",
    section: [
      {
        index: "被共済職員退職届の提出手続き",
        text: labelids.labelid.SCRC020002_09,
        link: "被共済職員退職届の提出手続き.pdf",
      },
      {
        index: "被共済職員退職届の取下げ手続き",
        text: labelids.labelid.SCRC020002_10,
        link: "被共済職員退職届の取下げ手続き.pdf",
      },
    ],
  },
  {
    title: "職員の異動",
    section: [
      {
        index: "配置換え登録手続き",
        text: labelids.labelid.SCRC020002_11,
        link: "配置換え登録手続き.pdf",
      },
    ],
  },
  {
    title: "本俸月額の更新・「俸給の調整額」対象手当の申請",
    section: [
      {
        index: "本俸月額の更新手続き",
        text: labelids.labelid.SCRC020002_12,
        link: "本俸月額の更新手続き.pdf",
      },
      {
        index: "「俸給の調整額」対象手当登録申請書の提出手続き",
        text: labelids.labelid.SCRC020002_13,
        link: "「俸給の調整額」対象手当登録申請書の提出手続き.pdf",
      },
    ],
  },
  {
    title: "共済契約者および施設情報の変更",
    section: [
      {
        index:
          "共済契約者氏名等変更届・共済契約証書再交付申出書の提出手続き（共済契約者名称等の変更の場合）",
        text: labelids.labelid.SCRC020002_14,
        link: "共済契約者氏名等変更届・共済契約証書再交付申出書の提出手続き（共済契約者名称等の変更の場合）.pdf",
      },
      {
        index: "共済契約者氏名等変更届の提出手続き（施設名称等の変更の場合）",
        text: labelids.labelid.SCRC020002_15,
        link: "共済契約者氏名等変更届の提出手続き（施設名称等の変更の場合）.pdf",
      },
    ],
  },
  {
    title: "職員の従業状況更新",
    section: [
      {
        index: "従業状況の更新手続き",
        text: labelids.labelid.SCRC020002_16,
        link: "従業状況の更新手続き.pdf",
      },
    ],
  },
  {
    title: "施設の廃止・契約解除にかかるお手続き",
    section: [
      {
        index: "共済契約対象施設等一部廃止等届の提出手続き",
        text: labelids.labelid.SCRC020002_17,
        link: "共済契約対象施設等一部廃止等届の提出手続き.pdf",
      },
      {
        index:
          "社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届の提出手続き",
        text: labelids.labelid.SCRC020002_18,
        link: "社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届の提出手続き.pdf",
      },
      {
        index: "中小企業退職手当金共済契約締結届の提出手続き",
        text: labelids.labelid.SCRC020002_19,
        link: "中小企業退職手当金共済契約締結届の提出手続き.pdf",
      },
      {
        index: "退職手当共済契約解除通知書の提出手続き",
        text: labelids.labelid.SCRC020002_20,
        link: "退職手当共済契約解除通知書の提出手続き.pdf",
      },
      {
        index: "退職手当共済契約部分解除通知書の提出手続き",
        text: labelids.labelid.SCRC020002_21,
        link: "退職手当共済契約部分解除通知書の提出手続き.pdf",
      },
    ],
  },
  {
    title: "施設の転換にかかるお手続き",
    section: [
      {
        index: "社会福祉施設等から特定介護保険施設等への転換届の提出手続き",
        text: labelids.labelid.SCRC020002_22,
        link: "社会福祉施設等から特定介護保険施設等への転換届の提出手続き.pdf",
      },
      {
        index:
          "施設を転換する日以後新たに使用する職員について加入させない旨の届の提出手続き",
        text: labelids.labelid.SCRC020002_23,
        link: "施設を転換する日以後新たに使用する職員について加入させない旨の届の提出手続き.pdf",
      },
      {
        index: "制度改正後の職員にかかる非加入届等の取下げ届の提出手続き",
        text: labelids.labelid.SCRC020002_24,
        link: "制度改正後の職員にかかる非加入届等の取下げ届の提出手続き.pdf",
      },
    ],
  },
  {
    title: "メールアドレス・パスワード変更",
    section: [
      {
        index: "退職手当共済システムパスワードの再設定手続き",
        text: labelids.labelid.SCRC020002_25,
        link: "退職手当共済システムパスワードの再設定手続き.pdf",
      },
      {
        index:
          "退職手当共済システム登録メールアドレスの変更申請及びパスワードの再設定手続き",
        text: labelids.labelid.SCRC020002_26,
        link: "退職手当共済システム登録メールアドレスの変更申請及びパスワードの再設定手続き.pdf",
      },
    ],
  },
  {
    title: "退職者様向けのお手続き",
    introduction: labelids.labelid.SCRC020002_27,
    section: [
      {
        index: "退職手当金請求書の提出手続き",
        text: labelids.labelid.SCRC020002_28,
        link: "退職手当金請求書の提出手続き.pdf",
      },
      {
        index: "退職手当金請求書の取下げ手続き",
        text: labelids.labelid.SCRC020002_29,
        link: "退職手当金請求書の取下げ手続き.pdf",
      },
      {
        index: "退職手当金振込先金融機関の変更手続き",
        text: labelids.labelid.SCRC020002_30,
        link: "退職手当金振込先金融機関の変更手続き.pdf",
      },
      {
        index: "退職者の死亡による退職手当金受領者の変更手続き",
        text: labelids.labelid.SCRC020002_31,
        link: "退職者の死亡による退職手当金受領者の変更手続き.pdf",
      },
      {
        index: "合算制度利用申出書（退職時）の提出手続き",
        text: labelids.labelid.SCRC020002_32,
        link: "合算制度利用申出書（退職時）の提出手続き.pdf",
      },
    ],
  },
];

export { manualList };
